export const PROJECT_STATS = {
  customerReviews: { value: 100, suffix: "+" },
  roomsAvailable: { value: 40, suffix: "", },
  customerSatisfaction: { value: 4.5, suffix: "/5", decimal: true },
};